import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import shared from "./modules/shared";
import tables from "./modules/tables";
import courses from "./modules/courses";
import profile from "./modules/profile";

export default new Vuex.Store({
  modules: {
    shared,
    tables,
    courses,
    profile,
  },
});
